export default __webpack_public_path__ + "static/media/guia-4.539e8791.png";